import init from './init'

document.addEventListener('DOMContentLoaded', init)
